export default "__VITE_PUBLIC_ASSET__5a37adaf__"